import { EditorState } from 'draft-js';
import createDecorator from './create-decorator';

export default function createResizeablePlugin (config) {
    const store = {
        getEditorRef: undefined,
        getReadOnly: undefined,
        getEditorState: undefined,
        setEditorState: undefined,
    };
    return {
        initialize: ({ getEditorRef, getReadOnly, getEditorState, setEditorState }) => {
            store.getReadOnly = getReadOnly;
            store.getEditorRef = getEditorRef;
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },

        decorator: createDecorator({ config, store }),

        blockRendererFn: (contentBlock, { getEditorState, setEditorState }) => {
            const entityKey = contentBlock.getEntityAt(0);
            const contentState = getEditorState().getCurrentContent();
            const resizeData = entityKey ? contentState.getEntity(entityKey).data : {};
            return {
                props: {
                    resizeData,
                    setResizeData: data /*{width,height}*/ => {
                        const entityKey = contentBlock.getEntityAt(0);
                        if (entityKey) {
                            const editorState = getEditorState();
                            const contentState = editorState.getCurrentContent();
                            contentState.mergeEntityData(entityKey, _.assign({}, data));
                            setEditorState(
                                EditorState.forceSelection(editorState, editorState.getSelection())
                            );
                        }
                    },
                },
            };
        },
    };
};